export default {
    namespaced: true,
    state: {
        tags: [],
    },
    getters: {
        getAll(state) {
            return state.tags;
        },
    },
    mutations: {
        setAll(state, tags) {
            Object.assign(state, {
                tags
            });
        },
    },
    actions: {
        async fetchAll(context) {
            const tags = await context.dispatch('api/request', {
                service: 'tag',
                type: 'getAll',
            }, { root: true });

            if (tags) {
                context.commit('setAll', tags);
            }
        },
    },
};
